import React, { Component } from 'react';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import '../../utils.css'
import Typography from '@material-ui/core/Typography';
import { getCurrentFunctionName } from '../../performanceModeManager';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { setSelectedType, setSelectedState, setStartDate, setEndDate, setNumberInput, setMaxAmount, setMinAmount, setFilteredAndSortedInvoices, setDisplayAsList } from '../../redux/invoices/invoicesActions';
import { ALL_SELECT_OPTION } from '../../constants';
import { Fab, Hidden, Icon, IconButton, InputAdornment, Switch } from '@material-ui/core';
import TextFieldWithTypingTimeout from '../Input/TextFieldWithTypingTimeout';
import { formatType } from '../../redux/invoices/invoicesTypesActions';
import { formatStatus } from '../../redux/invoices/invoicesStatusActions';
import CustomizedSelect from '../Input/CustomizedSelect';

class InvoicesFilters extends Component {
    onTypeChange(e) {
        this.props.setSelectedType(e.target.value)
    }

    onStateChange(e) {
        this.props.setSelectedState(e.target.value)
    }

    onStartDateChange(date) {
        this.props.setStartDate(date);
    }

    onEndDateChange(date) {
        this.props.setEndDate(date);
    }

    onMinInputChange(minAmount) {
        this.props.setMinAmount(minAmount)
    }

    clearMinInput() {
        this.props.setMinAmount('')
    }

    onMaxInputChange(maxAmount) {
        this.props.setMaxAmount(maxAmount)
    }

    clearMaxInput() {
        this.props.setMaxAmount('')
    }

    onNumberInputChange(numberInput) {
        this.props.setNumberInput(numberInput)
    }

    clearNumberInput() {
        this.props.setNumberInput('')
    }

    search() {
        this.props.setFilteredAndSortedInvoices({ ...this.props.invoices }, this.props.affair, this.props.intervention,
            this.props.tableState, this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults)
    }

    setDisplayAsList() {
        this.props.setDisplayAsList(!this.props.invoices.displayAsList)
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let stateElements = this.props.invoices.states.map((s) => (
            <MenuItem key={s} value={s}>
                <Typography variant="inherit" noWrap>{formatStatus(s)}</Typography>
            </MenuItem>
        ))

        stateElements.unshift(
            <MenuItem key={"none"} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>
        )

        let typesElement = this.props.invoices.types.map((t) => (
            <MenuItem key={t} value={t}>
                <Typography variant="inherit" noWrap>{formatType(t)}</Typography>
            </MenuItem>
        ))

        typesElement.unshift(
            <MenuItem key={"none"} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>
        )

        let searchBtnElement = (
            <Fab variant="extended" type="submit" color="secondary" className="element-right" onClick={this.search.bind(this)}>
                <Icon>search</Icon>
                Rechercher
            </Fab>
        );

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin filters-card">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding" >
                        <InputLabel htmlFor="type">{"Type"}</InputLabel>
                        <CustomizedSelect id="type" name="type" value={this.props.invoices.selectedType}
                            onChange={this.onTypeChange.bind(this)}>
                            {typesElement}
                        </CustomizedSelect>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding" >
                        <InputLabel htmlFor="state">{"Etat"}</InputLabel>
                        <CustomizedSelect id="state" name="state" value={this.props.invoices.selectedState}
                            onChange={this.onStateChange.bind(this)}>
                            {stateElements}
                        </CustomizedSelect>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <MuiPickersUtilsProvider
                            locale={"fr"}
                            utils={MomentUtils}
                            moment={moment}
                        >
                            <DatePicker
                                name="start-date"
                                value={this.props.invoices.startDate}
                                onChange={this.onStartDateChange.bind(this)}
                                label="Du"
                                clearable
                                clearLabel="Effacer"
                                invalidDateMessage="La date est invalide"
                                invalidLabel="La date est invalide"
                                cancelLabel="Annuler"
                                format="DD/MM/YYYY"
                                className="full_size"
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <MuiPickersUtilsProvider
                            locale={"fr"}
                            utils={MomentUtils}
                            moment={moment}
                        >
                            <DatePicker
                                name="end-date"
                                value={this.props.invoices.endDate}
                                onChange={this.onEndDateChange.bind(this)}
                                label="Au"
                                clearable
                                clearLabel="Effacer"
                                invalidDateMessage="La date est invalide"
                                invalidLabel="La date est invalide"
                                cancelLabel="Annuler"
                                format="DD/MM/YYYY"
                                className="full_size"
                            />
                        </MuiPickersUtilsProvider>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 row without-side-padding" >
                        <TextFieldWithTypingTimeout
                            id={"min"}
                            label={"Min (HT)"}
                            type="number"
                            className="full_size"
                            value={this.props.invoices.minAmount}
                            onValueChange={this.onMinInputChange.bind(this)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        <IconButton aria-label="Effacer" onClick={this.clearMinInput.bind(this)}>
                                            <Icon className="red-icon">close</Icon>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 row without-side-padding" >
                        <TextFieldWithTypingTimeout
                            id={"max"}
                            label={"Max (HT)"}
                            type="number"
                            className="full_size"
                            value={this.props.invoices.maxAmount}
                            onValueChange={this.onMaxInputChange.bind(this)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        <IconButton aria-label="Effacer" onClick={this.clearMaxInput.bind(this)}>
                                            <Icon className="red-icon">close</Icon>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 row without-side-padding" >
                        <TextFieldWithTypingTimeout
                            id={"number"}
                            label={"Numéro"}
                            className="full_size"
                            value={this.props.invoices.numberInput}
                            onValueChange={this.onNumberInputChange.bind(this)}
                            InputProps={{
                                endAdornment: (
                                    < InputAdornment position="end" >
                                        <IconButton aria-label="Effacer" onClick={this.clearNumberInput.bind(this)}>
                                            <Icon className="red-icon">close</Icon>
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </FormControl>
                    <Hidden only={['sm', 'xs']}>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding without-side-margin control-margin-top row switch-label">
                            <div className="offset-xl-1 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 right span-center-verticaly without-side-padding">
                                <span className={!this.props.invoices.displayAsList ? "green-selected-label" : ""}>Cartes</span>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding div-center">
                                <Switch onChange={this.setDisplayAsList.bind(this)}
                                    checked={this.props.invoices.displayAsList}
                                    className="switch" color="default"
                                    label={"Liste"} />
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding span-center-verticaly">
                                <span className={this.props.invoices.displayAsList ? "green-selected-label" : ""}>Liste</span>
                            </div>
                        </div>
                        <div className="offset-lg-9 col-lg-3 offset-md-4 col-md-4 control-margin-top">
                            {searchBtnElement}
                        </div>
                    </Hidden>
                    <Hidden only={['xl', 'lg', 'md']}>
                        <div className="offset-md-4 col-md-4 offset-sm-0 col-sm-6 offset-4 col-8 control-margin-top">
                            {searchBtnElement}
                        </div>
                    </Hidden>
                </CardContent>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        invoices: state.invoices,
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedType: (value, invoicesFilters) => dispatch(setSelectedType(value, invoicesFilters)),
        setSelectedState: (value, invoicesFilters) => dispatch(setSelectedState(value, invoicesFilters)),
        setStartDate: (value, invoicesFilters) => dispatch(setStartDate(value, invoicesFilters)),
        setEndDate: (value, invoicesFilters) => dispatch(setEndDate(value, invoicesFilters)),
        setNumberInput: (value, invoicesFilters) => dispatch(setNumberInput(value, invoicesFilters)),
        setMaxAmount: (value, invoicesFilters) => dispatch(setMaxAmount(value, invoicesFilters)),
        setMinAmount: (value, invoicesFilters) => dispatch(setMinAmount(value, invoicesFilters)),
        setFilteredAndSortedInvoices: (invoicesFilters, affair, intervention, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedInvoices(invoicesFilters, affair, intervention, tableState, user, customerSiteId, allSites, nbTotalResults)),
        setDisplayAsList: (value) => dispatch(setDisplayAsList(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicesFilters);
